import React, { useEffect } from "react";
import "./App.css";
import { createTheme, Paper, ThemeProvider } from "@mui/material";
import { red } from "@mui/material/colors";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { useDarkMode } from "./hooks";
// Importar as rotas
import {
  Manutencao,
  Raiz,
  Curriculo,
  CadastroMensagens,
  CurriculoEstatisticas,
  EsqueciASenha,
  RecuperarSenhaUsuario,
} from "./routes";
import { Header, BottomNavigation } from "./components";
import { useDispatch, useSelector } from "react-redux";
import { usuarioGetDadosUsuario } from "./redux/actions";
import ConfiguracoesDoUsuario from "./routes/ConfiguracoesDoUsuario";
import { ToastContainer } from "react-toastify";
//
const ROTAS = [
  ["/", Raiz], // Raz do site
  ["/curriculo", Curriculo], // Principal pagina que exibe os curriculos
  ["/manutencao", Manutencao], // Para manutencao de usuários e outros casos
  ["/cadastro_mensagens", CadastroMensagens], // Para configuração das mensagens
  ["/configuracoes_do_usuario", ConfiguracoesDoUsuario], // Para a area de configuraçoes do usuario
  ["/curriculo_estatisticas", CurriculoEstatisticas], // Para recuperar estatisticas dos curriculos
  ["/esqueci_a_senha", EsqueciASenha], // Para usuario que esqueceu a senha
  ["/recuperar_senha_usuario", RecuperarSenhaUsuario], // Define o local de insercao da nova senha
];

function App() {
  const [darkMode, setDarkMode] = useDarkMode();
  const usuario = useSelector((state) => state.usuario);
  const dispatch = useDispatch();
  // Buscar uma atualizacao de dados
  useEffect(() => {
    dispatch(usuarioGetDadosUsuario());
  }, [dispatch]);

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
      primary: darkMode
        ? {
            main: red["600"],
            //main: red['A700'],
          }
        : {
            main: "#b71c1c",
          },
      secondary: darkMode
        ? {
            main: "#c6f68d",
          }
        : {
            main: "#008b00",
          },
    },
  });
  const {
    breakpoints: { values },
  } = theme;
  // Verifica se e mobile
  const isMobile = values["sm"] > window.innerWidth;

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="bottom-center" />
      <Paper elevation={0} style={{ minHeight: "100vh" }}>
        <Router>
          <Header
            usuario={usuario}
            isMobile={isMobile}
            isAdmin={usuario?.admin === "S"}
            handleDarkMode={() => setDarkMode(!darkMode)}
          />
          {ROTAS.map((ele, idx) => (
            <Route component={ele[1]} exact path={ele[0]} key={idx} />
          ))}
          <br /> <br />
          <br />
          {isMobile && usuario && <BottomNavigation isAdmin={usuario?.admin} />}
        </Router>
      </Paper>
    </ThemeProvider>
  );
}

export default App;
